export enum bordEnum {
	debut = 'debut',
	fin = 'fin',
	aucun = 'aucun',
}